export const getTimeFromIsoDate = (isoDate: string | undefined): string => {
  const date = isoDate?.split('T').pop();
  return date ?? '';
};
